import React, { useEffect, useRef, useState } from 'react'
import Select from 'react-select';
// import * as dayjs from 'dayjs';
import { getCityList, getStreetList, getBuildingNames, getBuildingGroups, getChergList, getAccountsByNumber } from '../Axios/searchoff';
// import Table from 'react-bootstrap/Table';
import { ToastContainer } from "react-toastify";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import PaginationLoe from './PaginationLoe';
import { defaultOptions, filterOption, selectOptions } from '../utils/search';
import GroupPage from '../pages/GroupPage';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';
import { sortDataLabel, getCookie, setCookie, eraseCookie } from '../utils/utils';

const GroupSerach = () => {

  const [selectedCity, setSelectedCity] = useState(null);
  const [selectedStreet, setSelectedStreet] = useState(null);
  const [selectedBuilding, setSelectedBuilding] = useState(null);
  const [selectedAccounts, setSelectedAccounts] = useState(null);

  const [cityOptions, setCityOptions] = useState([]);
  const [streetOptions, setStreetOptions] = useState([]);
  const [buildingOptions, setBuildingOptions] = useState([]);
  const [buildingGroups, setBuildingGroups] = useState([]);

  // const [podiysList, setPodiysList] = useState([]);
  const [border, setBorder] = useState({ otg: '#C4CBD2', city: '#C4CBD2', street: '#C4CBD2', building: '#C4CBD2' });
  const [color, setColor] = useState({ otg: 'hsl(0, 0%, 50%)', city: 'hsl(0, 0%, 50%)', street: 'hsl(0, 0%, 50%)', building: 'hsl(0, 0%, 50%)' });

  const formRef = useRef(null);
  const citySelect = useRef(null);
  const streetSelect = useRef(null);
  const buildingSelect = useRef(null);
  const [selectedChergKeys, setSelectedChergKeys] = useState([]);
  const [chergList, setChergList] = useState({});
  const [history, setHistory] = useState([]);

  useEffect(() => {
    const savedHistory = getCookie('search_history');
    if (savedHistory) {
      setHistory(savedHistory);
    }
  }, []);

  const addToHistory = (city, street, building, account) => {
    const newItem = { city, street, building, account };
    const newHistory = [newItem, ...history.filter(h =>
      h.city?.value !== city?.value ||
      h.street?.value !== street?.value ||
      h.building?.value !== building?.value ||
      h.account !== account
    )].slice(0, 5);

    setHistory(newHistory);
    setCookie('search_history', newHistory, 30);
  };

  const clearHistory = () => {
    setHistory([]);
    eraseCookie('search_history');
  };

  const fetchSchedules = () => {
    const initFrom = dayjs().subtract(1, "day").startOf('day').format("YYYY-MM-DDT12:00:00+00:00");
    const initTo = dayjs().add(1, "day").startOf('day').format('YYYY-MM-DDTHH:mm:ss+00:00');
    getChergList(initFrom, initTo).then((response) => {
      const data = response['hydra:member'];
      if (data.length === 2) {
        if (dayjs(data[1].dateGraph).isAfter(dayjs(data[0].dateGraph))) {
          setChergList({ current: data[0], tomorrow: data[1] })
        } else {
          setChergList({ current: data[1], tomorrow: data[0] })
        }
      }
      if (data.length === 1) {
        setChergList({ current: data[0], tomorrow: null })
      }
    }).catch(err => {
      console.log('помилка при запиті за графіками', err);
    });
  };

  const handleHistoryClick = (item) => {
    setSelectedCity(item.city);
    setSelectedStreet(item.street);
    setSelectedBuilding(item.building);
    setSelectedAccounts(item.account);
    fetchSchedules();
  };
  // const [totalItems, setTotal] = useState(1);
  // const [noOff, setNoOff] = useState('');

  useEffect(() => {
    selectOptions(getCityList, setCityOptions);
  }, []);

  useEffect(() => {
    if (selectedCity !== null) {
      selectOptions(getStreetList, (options) => {
        const cleanedOptions = options.map(opt => ({
          ...opt,
          label: opt.label.replace(/^вул(\.|\s)\s*/i, '')
        }));
        const sortedOptions = sortDataLabel(cleanedOptions);
        setStreetOptions([{ value: -1, label: 'Моєї вулиці немає в списку' }, ...sortedOptions]);
      }, selectedCity.value);
    }
  }, [selectedCity])

  useEffect(() => {
    if (selectedCity !== null || selectedStreet !== null || selectedBuilding !== null) {

      if (selectedCity?.value !== -1 && selectedStreet?.value !== -1 && selectedBuilding?.value !== -1) {
        getBuildingGroups(selectedCity, selectedStreet, selectedBuilding).then((buildingNames) => {
          const data = Array.isArray(buildingNames) ? buildingNames : [];
          const formatData = data.map((item) => {
            return { value: item.id, label: item.buildingName, chergGpv: item.chergGpv };
          });
          setBuildingGroups(formatData);

        }).catch((err) => {
          console.log(err.message);
          setBuildingGroups([]);
        });
      } else {
        setBuildingGroups([]);
      }
    } else {
      setBuildingGroups([]);
    }

    if (selectedCity !== null && selectedStreet !== null) {
      if (selectedStreet.value === -1) {
        setBuildingOptions([{ value: -1, label: 'Мого будинку немає в списку' }]);
      } else {
        getBuildingNames(selectedCity, selectedStreet).then((buildingNames) => {
          const data = Array.isArray(buildingNames) ? buildingNames : [];
          const formatData = data.map((item) => {
            return { value: item.id, label: item.buildingName, chergGpv: item.chergGpv };
          });
          setBuildingOptions([{ value: -1, label: 'Мого будинку немає в списку' }, ...formatData]);

        }).catch((err) => {
          console.log(err.message);
          setBuildingOptions([{ value: -1, label: 'Мого будинку немає в списку' }]);
        });
      }
    } else {
      setBuildingOptions([]);
    }
  }, [selectedCity, selectedStreet, selectedBuilding])

  useEffect(() => {
    if (selectedAccounts !== null) {
      getAccountsByNumber(selectedAccounts).then((accounts) => {
        console.log(accounts);

        const data = accounts.data;
        console.log(data);
        setBuildingGroups([{ value: data.id, label: data.buildingName, chergGpv: data.chergGpv }]);
      }).catch((err) => {
        console.log(err.message);
        setBuildingGroups([]);
      });
    } else {
      setBuildingGroups([]);
    }
  }, [selectedAccounts])


  useEffect(() => {
    setSelectedChergKeys(buildingGroups.map((item) => item.chergGpv));
  }, [buildingGroups])
  useEffect(() => {
    console.log('selectedChergKeys', selectedChergKeys);
  }, [selectedChergKeys])

  function alertClolors(type) {
    setBorder({ ...border, [type]: '#e74c3c' });
    setColor({ ...color, [type]: '#e74c3c' });
    setTimeout(() => {
      setBorder({ ...border, [type]: '#C4CBD2' });
      setColor({ ...color, [type]: 'hsl(0, 0%, 50%)' });
    }, 4000);
  }

  function handleSubmit(e) {
    e.preventDefault();
    fetchSchedules();
    addToHistory(selectedCity, selectedStreet, selectedBuilding, selectedAccounts);
  }

  const statusToBg = (status) => {
    // "1"  = off
    // "0"  = on
    // "10" = maybe / possible
    if (status === '1') return { backgroundColor: '#1F1755', color: '#FFFFFF' }; // off - синій
    if (status === '10') return { backgroundColor: '#B3B3B3', color: '#1F1755' }; // possible - сірий
    return { backgroundColor: '#FFFFFF', color: '#1F1755' }; // on
  };

  const buildHourBlocks = (times = {}) => {
    const blocks = [];
    for (let h = 0; h < 24; h += 1) {
      const hh = String(h).padStart(2, '0');
      blocks.push({
        hour: hh,
        min: '00',
        s00: times[`${hh}:00`] ?? '0',
        s30: times[`${hh}:30`] ?? '0',
      });
    }
    return blocks;
  };

  const Message = () => {
    if (selectedCity == null && selectedStreet == null && selectedBuilding == null) {
      return <p style={{ textAlign: "center" }}></p>
    }

    if ((selectedChergKeys.length === 1 && selectedChergKeys.includes("Не входить") || selectedChergKeys.length === 0)) {
      /** Якщо обрано 1 чергу і це "Не входить" або не обрано жодної черги */
      return <p style={{ textAlign: "center" }}>За вашою адресою не застосовуються графіки погодинних вимкнень. <Link to={"/send-off"}>Повідомлення диспетчеру</Link></p>
    } else {
      /** Якщо обрано місто */
      if (selectedCity && (selectedStreet == null || selectedStreet == ''))
        return <p style={{ textAlign: "center" }}>Знайдено кілька Графіків погодинних вимкнень, уточніть пошук, <strong>вкажіть вулицю</strong>, якщо Вашої вулиці не знайдено подайте <Link to={"/send-off"}>повідомлення диспетчеру</Link></p>

      /** Якщо обрано місто і вулицю */
      if (selectedCity && selectedStreet && (selectedBuilding == null || selectedBuilding == ''))
        return <p style={{ textAlign: "center" }}>Знайдено кілька Графіків погодинних вимкнень, уточніть пошук, вкажіть <strong>номер будинку</strong>, якщо Вашого будинку нема в списку подайте <Link to={"/send-off"}>повідомлення диспетчеру</Link></p>

      /** Якщо обрано місто, вулицю і будинок */
      if (selectedCity && selectedStreet && selectedBuilding && selectedChergKeys.length >= 2)
        return <p style={{ textAlign: "center" }}>Знайдено кілька Графіків погодинних вимкнень, уточніть пошук, введіть номер Вашого особового рахунку.</p>
    }
    return <></>;
  }

  return (
    <div className="search-off search-group">
      <div className="container">
        <div className="search-group__content">
          <h2 className='power-off__title'>Скористайтесь формою для пошуку персоналізованого графіку за адресою споживача:</h2>
          <p>Раніше споживачі користувалися загальним графіком і шукали свою підчергу та години відключень самостійно.</p>
          <p>Відтепер у даному  розділі доступна оновлена функція: достатньо ввести адресу — і система покаже підчергу, години відключень та відновлення електропостачання.</p>
          <p>Це допоможе споживачам спланувати свій час та легше адаптуватися до тимчасових обмежень електропостачання.</p>
        </div>

        {history.length > 0 && (
          <div className="search-history" style={{ marginBottom: '20px' }}>
            <div className="history-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
              <h3 style={{ margin: 0 }}>Історія пошуку:</h3>
              <button onClick={clearHistory} className="power-btn" style={{ padding: '5px 10px', fontSize: '14px', width: 'auto' }}>Очистити історію</button>
            </div>
            <div className="history-list">
              {history.map((item, index) => (
                <div
                  key={index}
                  className="history-item"
                  onClick={() => handleHistoryClick(item)}
                  style={{
                    cursor: 'pointer',
                    padding: '10px',
                    border: '1px solid #ddd',
                    marginBottom: '5px',
                    borderRadius: '4px',
                    backgroundColor: '#f9f9f9'
                  }}
                >
                  {item.city?.label}, {item.street?.label}, {item.building?.label} {item.account ? `(ОР: ${item.account})` : ''}
                </div>
              ))}
            </div>
          </div>
        )}

        <form action="submit" onSubmit={handleSubmit} ref={formRef} data-aos="fade-up">
          <label htmlFor="city">Населений пункт*</label>
          <Select
            cacheOptions
            ref={citySelect}
            // value={selectedCity} 
            // ^ Actually, if I add value, I need to make sure I don't break clearValue? No, clearValue clears internal state or calls onChange with null.
            // Let's add value={selectedCity}.
            value={selectedCity}
            id={'city'}
            placeholder={'Введіть назву населеного пункту'}
            onChange={setSelectedCity}
            defaultOptions={defaultOptions}
            options={cityOptions}
            noOptionsMessage={() => 'Адреси не знайдено'}
            loadingMessage={() => 'Завантаження...'}
            onSelectResetsInput={false}
            filterOption={filterOption}
            onMenuOpen={() => {
              citySelect.current.clearValue();
              streetSelect.current.clearValue();
              buildingSelect.current?.clearValue();
              setSelectedAccounts(null);
            }}
            styles={{
              control: (baseStyles, state) => ({
                ...baseStyles,
                border: `1px solid ${border.city}`,
                width: '400px',
                display: 'flex',
                height: '58px',
                borderRadius: '4px',
                background: state.isDisabled ? 'hsl(0, 0%, 95%)' : 'white',
                borderColor: state.isDisabled ? 'hsl(0, 0%, 90%)' : `1px solid ${border.city}`,
                cursor: state.isDisabled ? 'not-allowed' : 'pointer',
                paddingLeft: '10px',
                opacity: state.isDisabled ? 0.7 : 1
              }),
              placeholder: (baseStyles, state) => ({
                ...baseStyles,
                color: state.isDisabled ? 'hsl(0, 0%, 50%);' : color.city
              })
            }}
            onFocus={() => { setBorder({ ...border, city: '#C4CBD2' }); setColor({ ...color, city: 'hsl(0, 0%, 50%)' }) }}
          />
          <label htmlFor="street">Вулиця*</label>
          <Select
            cacheOptions
            ref={streetSelect}
            value={selectedStreet}
            id={'street'}
            placeholder={(selectedCity === null) ? 'Заповніть поле "Населений пункт"' : "Введіть назву вулиці"}
            onChange={setSelectedStreet}
            options={streetOptions}
            noOptionsMessage={() => 'Адреси не знайдено'}
            loadingMessage={() => 'Завантаження...'}
            isDisabled={selectedCity === null}
            onMenuOpen={() => {
              streetSelect.current.clearValue();
              buildingSelect.current?.clearValue();
              setSelectedBuilding(null);
            }}
            styles={{
              control: (baseStyles, state) => ({
                ...baseStyles,
                border: `1px solid ${border.street}`,
                width: '400px',
                display: 'flex',
                height: '58px',
                borderRadius: '4px',
                background: state.isDisabled ? 'hsl(0, 0%, 95%)' : 'white',
                borderColor: state.isDisabled ? 'hsl(0, 0%, 90%)' : `1px solid ${border.street}`,
                cursor: state.isDisabled ? 'not-allowed' : 'pointer',
                paddingLeft: '10px',
                opacity: state.isDisabled ? 0.9 : 1
              }),
              placeholder: (baseStyles, state) => ({
                ...baseStyles,
                color: state.isDisabled ? 'hsl(0, 0%, 50%);' : color.street
              })
            }}
            onFocus={() => { setBorder({ ...border, street: '#C4CBD2' }); setColor({ ...color, street: 'hsl(0, 0%, 50%)' }) }}
          />
          <label htmlFor="building">Будинок*</label>
          <Select
            cacheOptions
            ref={buildingSelect}
            value={selectedBuilding}
            id={'building'}
            placeholder={(selectedCity === null || selectedStreet === null) ? 'Заповніть "Населений пункт" та "Вулиця"' : "Введіть номер будинку"}
            onChange={setSelectedBuilding}
            options={buildingOptions}
            noOptionsMessage={() => 'Будинки не знайдено'}
            loadingMessage={() => 'Завантаження...'}
            isDisabled={selectedCity === null || selectedStreet === null}
            onMenuOpen={() => { buildingSelect.current?.clearValue(); setSelectedAccounts(null); }}
            styles={{
              control: (baseStyles, state) => ({
                ...baseStyles,
                border: `1px solid ${border.building}`,
                width: '400px',
                display: 'flex',
                height: '58px',
                borderRadius: '4px',
                background: state.isDisabled ? 'hsl(0, 0%, 95%)' : 'white',
                borderColor: state.isDisabled ? 'hsl(0, 0%, 90%)' : `1px solid ${border.building}`,
                cursor: state.isDisabled ? 'not-allowed' : 'pointer',
                paddingLeft: '10px',
                opacity: state.isDisabled ? 0.9 : 1
              }),
              placeholder: (baseStyles, state) => ({
                ...baseStyles,
                color: state.isDisabled ? 'hsl(0, 0%, 50%);' : color.building
              })
            }}
            onFocus={() => { setBorder({ ...border, building: '#C4CBD2' }); setColor({ ...color, building: 'hsl(0, 0%, 50%)' }) }}
          />
          {(selectedCity && selectedStreet && selectedBuilding && (selectedChergKeys.length >= 2 || selectedAccounts || selectedStreet.value === -1 || selectedBuilding.value === -1)) &&
            <input className="input-search" type="number" placeholder="Особовий рахунок" value={selectedAccounts || ''} onChange={(e) => setSelectedAccounts(e.target.value)} />
          }
          <button className='power-btn'>Знайти</button>
          <ToastContainer />
        </form>
        {(selectedCity || selectedStreet || selectedBuilding || selectedAccounts) &&
          <div className="search-off__selected" style={{ paddingTop: "20px" }}>
            <p>Вибрано:&nbsp;
              <i>
                {(selectedCity) ? selectedCity.label : ""} &nbsp;
                {(selectedStreet) ? selectedStreet.label : ""} &nbsp;
                {(selectedBuilding) ? selectedBuilding.label : ""} &nbsp;
                {(selectedAccounts) ? selectedAccounts : ""}
              </i>
            </p>
          </div>
        }
        {(selectedChergKeys.length == 1 && Object.keys(chergList).length > 0 && !selectedChergKeys.includes("Не входить")) &&
          <>
            <div className="search-off__timeline">
              {selectedChergKeys.map((chergKey) => {
                const key = String(chergKey).trim();
                const chergData = chergList.current.dataJson;
                const timesObj = chergData?.[key]?.times || {};

                return (
                  <div className="queue-card" key={chergKey}>
                    <div className="queue-card__header">
                      <div className="queue-card__title">
                        <span className="queue-card__date">{dayjs(chergList.current.dateGraph).format("DD.MM.YYYY")}</span>
                        <span className="queue-card__cherg">Черга {chergKey}</span>
                      </div>
                    </div>
                    <div
                      className="queue-grid"
                      role="grid"
                      aria-label={`Графік для черги ${chergKey}`}
                    >
                      {buildHourBlocks(timesObj).map((b) => (
                        <div
                          className="queue-hour"
                          role="gridcell"
                          key={`${chergKey}-${b.hour}:${b.min}`}
                          title={`${b.hour}:${b.min} - ${b.s00}/${b.s30}`}
                        >
                          <div className="queue-hour__halves">
                            <div
                              className="queue-hour__half s00"
                              style={statusToBg(b.s00)}
                            >
                              {b.hour}
                            </div>
                            <span style={{ position: "absolute", color: statusToBg(b.s00).color }}>:</span>
                            <div
                              className="queue-hour__half s30"
                              style={statusToBg(b.s30)}
                            >
                              {b.min}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                );
              })}

              <div className="search-off__timeline">
                {chergList.tomorrow && selectedChergKeys.map((chergKey) => {
                  const key = String(chergKey).trim();
                  const chergData = chergList.tomorrow.dataJson;
                  const timesObj = chergData?.[key]?.times || {};

                  return (
                    <div className="queue-card" key={chergKey}>
                      <div className="queue-card__header">
                        <div className="queue-card__title">
                          <span className="queue-card__date">{dayjs(chergList.tomorrow.dateGraph).format("DD.MM.YYYY")}</span>
                          <span className="queue-card__cherg">Черга {chergKey}</span>
                        </div>
                      </div>
                      <div
                        className="queue-grid"
                        role="grid"
                        aria-label={`Графік для черги ${chergKey}`}
                      >
                        {buildHourBlocks(timesObj).map((b) => (
                          <div
                            className="queue-hour"
                            role="gridcell"
                            key={`${chergKey}-${b.hour}:${b.min}`}
                            title={`${b.hour}:${b.min} - ${b.s00}/${b.s30}`}
                          >
                            <div className="queue-hour__halves">
                              <div
                                className="queue-hour__half s00"
                                style={statusToBg(b.s00)}
                              >
                                {b.hour}
                              </div>
                              <span style={{ position: "absolute", color: statusToBg(b.s00).color }}>:</span>
                              <div
                                className="queue-hour__half s30"
                                style={statusToBg(b.s30)}
                              >
                                {b.min}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  );
                })}
              </div>

            </div>
            {/* <PaginationLoe
               changePage={handleChangePage}
               currentPage={page}
               total={totalItems}
           />  */}
            <div className="search-off__timeline-descr">
              <p>Якщо у вас відсутня електроенергія хоча згідно графіку вона має бути,</p>
              <p>Ви можете подати повідомлення про відсутність електроенергії на цій сторінці <Link to={"/send-off"}>"Повідомлення про відсутність електроенергії"</Link></p>
            </div>
            <div>
              <div className="search-off__queue-descr">
                <div
                  className="queue-hour"
                  role="gridcell"
                >
                  <div className="queue-hour__halves">
                    <div
                      className="queue-hour__half s00"
                      style={{ backgroundColor: "#FFFFFF", color: '#1F1755' }}
                    >
                      09
                    </div>
                    <span style={{ position: "absolute", color: "#1F1755" }}>:</span>
                    <div
                      className="queue-hour__half s30"
                      style={{ backgroundColor: '#FFFFFF', color: '#1F1755' }}
                    >
                      00
                    </div>
                  </div>
                </div>
                <span>
                  — подача електроенергії
                </span>
              </div>
              <div className="search-off__queue-descr">
                <div
                  className="queue-hour"
                  role="gridcell"
                >
                  <div className="queue-hour__halves">
                    <div
                      className="queue-hour__half s00"
                      style={{ backgroundColor: "#FFFFFF", color: '#1F1755' }}
                    >
                      10
                    </div>
                    <span style={{ position: "absolute", color: "#1F1755" }}>:</span>
                    <div
                      className="queue-hour__half s30"
                      style={{ backgroundColor: '#B3B3B3', color: '#1F1755' }}
                    >
                      00
                    </div>
                  </div>
                </div>
                <span>
                  — час на перемикання (можлива відсутність електроенергії)
                </span>
              </div>
              <div className="search-off__queue-descr">
                <div
                  className="queue-hour"
                  role="gridcell"
                >
                  <div className="queue-hour__halves">
                    <div
                      className="queue-hour__half s00"
                      style={{ backgroundColor: '#1F1755', color: '#FFFFFF' }}
                    >
                      11
                    </div>
                    <span style={{ position: "absolute", color: "#FFFFFF" }}>:</span>
                    <div
                      className="queue-hour__half s30"
                      style={{ backgroundColor: '#1F1755', color: '#FFFFFF' }}
                    >
                      00
                    </div>
                  </div>
                </div>
                <span>
                  — вимкнення електроенергії
                </span>
              </div>
            </div>
          </>}
        {/* {(selectedChergKeys.length > 0 && Object.keys(chergList).length > 0) && <> */}
        <div className="search-off__timeline-descr" style={{ paddingTop: "20px" }}>
          <Message />
        </div>
        {/* </>} */}
      </div>
    </div>
  )
}

export default GroupSerach